import { NgInterceptor } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { eEnvironment, IRootScope } from "@models";
import { Utils } from "@tools";

@NgInterceptor({
    token: Token.CacheBusterInterceptor,
    dependencies: [
        Token.$Injector,
        Token.$RootScope,
        Token.$TemplateCache,
        Token.$Q,
    ]
})
export class CacheBusterInterceptor {
    constructor(
        private $injector: ng.auto.IInjectorService,
        private $rootScope: IRootScope,
        private $templateCache: ng.ITemplateCacheService,
        private $q: ng.IQService
    ) {

        return {
            request: (config: ng.IRequestConfig) => {
                // if it's already in the templatecache, then just get it from there
                if ($templateCache.get(config.url)) {
                    return config;
                }

                if (config.method == "GET") {
                    // we only cache-bust stuff from our own server.  Presumably these requests will have a relative url
                    if (!Utils.isAbsoluteUrl(config.url)) {
                        let extension = Utils.getExtension(config.url) || "";
                        extension = extension.toLowerCase();

                        // non file calls in the test and prod environments should send the last deploy,
                        // which allows the browser cache to store results for some calls
                        let company = this.$rootScope.company;
                        let env = this.$rootScope.environment;
                        if (env != eEnvironment.dev) {
                            let lastDeploy = (env == eEnvironment.test ? company.lastTestDeployment : company.lastProdDeployment);
                            if (!extension) {
                                let prefix = "?";
                                if (config.url.search("\\?") !== -1) {
                                    prefix = "&";
                                }
                                config.url += `${prefix}d=${lastDeploy}&v=${$rootScope.cacheBuster}`;
                            }
                        }
                    }
                }

                return config;
            }
        } as any;
    }
}
